import { createUserWithEmailAndPassword } from 'firebase/auth';
import { useState} from 'react';
import { auth } from '../../firebase';
import { useTheme  } from '../../context/ThemeContext';
import { Link, useNavigate } from 'react-router-dom';
import { UserAuth } from '../../context/AuthContext';
import ReCAPTCHA from 'react-google-recaptcha';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import temisLight from '../../images/loginLight.png'; 
import temisDark from '../../images/loginDark.png'; 
import './login-signup.css';

const SignUp = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const { createUser, signInWithGooglePopup } = UserAuth();
    const navigate = useNavigate();
    const [isVerified, setIsVerified] = useState(false);
    const { isDarkMode, themeClass, toggleTheme } = useTheme();

    const onChange = (value) => {
        setIsVerified(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isVerified) {
            try {
                await createUser(email, password);
                navigate('/account');
            } catch (e) {
                let message;
                switch (e.code) {
                    case 'auth/email-already-in-use':
                        message = 'Este correo electrónico ya está en uso. Por favor, intenta con otro.';
                        break;
                    case 'auth/invalid-email':
                        message = 'Correo electrónico inválido. Por favor, ingresa un correo electrónico válido.';
                        break;
                    case 'auth/weak-password':
                        message = 'La contraseña es muy débil. Por favor, ingresa una contraseña más segura.';
                        break;
                    default:
                        message = 'Ocurrió un error. Por favor, intenta nuevamente.';
                }
                setError(message);
                setIsVerified(false);
            }
        } else {
            alert('Por favor verifica que no eres un robot.');
        }
    };

    const handleGoogleSignIn = async () => {
        try {
            await signInWithGooglePopup();
            setIsVerified(true);
            navigate('/account');
        } catch (error) {
            console.error(error);
            alert('No se pudo iniciar sesión con Google');
        }
    };

    return (
        <div className={`signup-container ${themeClass}`}>
            <div className={`topButtons ${themeClass}`}>
                {/* Toggle de Tema */}
                <div className="header-left">
                    <div className="theme-toggle">
                        <span className="colorIconToggle" >☼</span>
                        <label className="toggle-switch">
                        <input
                            type="checkbox"
                            checked={isDarkMode}
                            onChange={toggleTheme}
                            className="toggle-input"
                        />
                        <span className={`toggle-slider ${themeClass}`}>
                            <span className={`toggle-knob ${themeClass}`} />
                        </span>
                        </label>
                        <span className="colorIconToggle">☽</span>
                    </div>
                </div>
                <Link to='/' className={`back-button ${themeClass}`}>
                    ⟨ &nbsp;&nbsp; Regresar
                </Link>
            </div>

            <div className="signupcontainer">
                <img 
                    src={isDarkMode ? temisDark  : temisLight} 
                    alt="temis" 
                    className="iconT"
                />

                <h1 className={`signup-title ${themeClass}`}>
                    Regístrate para obtener asesoría legal rápida y confiable
                </h1>

                {error && <div className="error-message">{error}</div>}

                <button className={`google-button ${themeClass}`} onClick={handleGoogleSignIn}>
                    <FontAwesomeIcon icon={faGoogle} className="google-icon" />
                    <div className={`google-txt ${themeClass}`} >Continuar con Google</div>
                </button>

                <div className={`divider ${themeClass}`}>
                    <div className={`linea ${themeClass}`}/>
                    o
                    <div className={`linea ${themeClass}`}/>
                </div>

                <form onSubmit={handleSubmit} className="signup-form">
                    <label className="input-label">Correo electrónico</label>
                    <input
                        className={`input-field ${themeClass}`}
                        type='email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />

                    <label className="input-label" >Contraseña</label>
                    <input
                        className={`input-field ${themeClass}`}
                        type='password'
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />

                    <div className="recaptcha-container">
                        <ReCAPTCHA 
                            sitekey="6LffcyMmAAAAAB8CKDyxexlZFUEmJAZ1VX-jbZaq" 
                            onChange={onChange} 
                        />
                    </div>

                    <div className='sigup-b'>
                        <button className={`color-button ${themeClass}`} type='submit'>
                            Crear cuenta
                        </button>
                    </div>
                </form>

                <div className="footer-text">
                    ¿Ya tienes una cuenta?{' '}
                    <Link to='/login' className="footer-link">Ingresa aquí</Link>
                </div>
            </div>
        </div>
    );
};

export default SignUp;